import { render, staticRenderFns } from "./ContentArchive.vue?vue&type=template&id=05376980&scoped=true"
import script from "./ContentArchive.vue?vue&type=script&lang=js"
export * from "./ContentArchive.vue?vue&type=script&lang=js"
import style0 from "./ContentArchive.vue?vue&type=style&index=0&id=05376980&prod&scoped=true&lang=css"
import style1 from "./ContentArchive.vue?vue&type=style&index=1&id=05376980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05376980",
  null
  
)

export default component.exports